

































































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import UiSlider from '@/components/ui/UiSlider.vue'
import UiLabel from '@/components/ui/UiLabel.vue'
import { masks } from '@/utils/plugins/inputMask'
import { yearName } from '@/utils/helpers/helpFunctions'
import VueI18n from 'vue-i18n'
import TranslateResult = VueI18n.TranslateResult

interface Data {
  price: string
  years: string
  initialPayment: string
  percent: string
}

interface Methods {
  getYearName: (value: number) => void
  endPriceSelect: (value: string) => void
  endInitialPaymentSelect: (value: string) => void
}

interface Computed {
  monthlyPayment: string
  expiryDate: string
  sumOfPayment: number
  timeInMonths: number
  percentNum: number
  expiryDateText: TranslateResult
}

interface Props {
  type: 'mortgage' | 'installment'
}

export default Vue.extend({
  name: 'CalculatorForm',
  components: {
    UiSlider,
    UiLabel
  },
  props: {
    type: {
      type: String,
      default: () => 'mortgage'
    }
  },
  data () {
    return {
      price: '8000000',
      years: '30',
      initialPayment: '2000000',
      percent: '0.1',
      masks
    }
  },
  computed: {
    monthlyPayment () {
      if (this.sumOfPayment < 0) return '0'
      if (this.type === 'installment') {
        return Math.round(this.sumOfPayment / this.timeInMonths).toLocaleString('ru')
      }

      return Math.round(this.sumOfPayment *
        (this.percentNum + this.percentNum / (Math.pow(1 + this.percentNum, this.timeInMonths) - 1))
      ).toLocaleString('ru')
    },
    expiryDate () {
      const now = new Date()
      const endDate = new Date(now.setMonth(now.getMonth() + this.timeInMonths))
      return this.$t(`app.calculator.dates.${endDate.getMonth()}`, { year: endDate.getFullYear() })
    },
    sumOfPayment () {
      return Number(this.price) - Number(this.initialPayment)
    },
    timeInMonths () {
      return 12 * Number(this.years)
    },
    percentNum () {
      return Number(this.percent) / 100 / 12
    },
    expiryDateText () {
      if (this.type === 'installment') return this.$t('app.calculator.expiryDateInstallment')

      return this.$t('app.calculator.expiryDateDefault')
    }
  },
  methods: {
    getYearName (value: number) {
      return yearName(value)
    },
    endPriceSelect (value: string) {
      if (value !== '' && Number(value) < Number(this.initialPayment)) this.initialPayment = value
    },
    endInitialPaymentSelect (value: string) {
      if (value !== '' && Number(this.price) < Number(value)) this.price = value
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
